import { getState, initialState } from '../../../../utils/widget-editor-module-generator/state-generator';

const state = getState();

// initialed state
export { initialState };

export default state;
